<template>
  <div class="answer-item d-flex align-items-center" :class="{ 'answer-item__selected': isSelected }"  @click="onSelect">
    <div class="answer-item__radius-check"></div>
    <span class="answer-item__label">{{ $t(label) }}</span>
  </div>
</template>

<script>
export default {
  name: 'AnswerItem',
  props: {
    isSelected: Boolean,
    answer: {
      id: Number,
      label: String,
    },
  },
  data() {
    return {
      selected: {
        type: Boolean,
        default: false
      }
    }
  },
  computed: {
    label() {
      return this.answer.label 
    }
  },
  methods: {
    onSelect() {
      this.$emit('onSelect');
    }
  },
}
</script>

<style scoped lang="scss">
  .answer-item {
    width: 100%;
    padding: 12px;
    border-radius: 6px;
    outline: solid 1px $light3;
    min-height: 56px;
    margin-bottom: 16px;
    cursor: pointer;
    transition: all 0.1s ease-in;

    &__selected {
      outline-color: $mono3;
      outline-width: 1px;
      .answer-item__radius-check {
        border: solid 4px #ffffff;
        outline: solid 1.5px $mono3;
        background-color: $mono3;
      }
    }

    &:hover:not(.answer-item__selected) {
      outline-color: $mono3;
      outline-width: 1px;
    }

    &__label {
      color: $textLightModeHigh;
      font-size: 16px;
      font-weight: 500;
      line-height: 150%;
    }

    &__radius-check {
      height: 20px;
      width: 20px;
      margin-right: 10px;
      outline: solid 1.5px $neutral7;
      border-radius: 50%;
      position: relative;
    }
  }
</style>
